import React from 'react';

import NewsListBlock from 'components/NewsListBlock';

const ArticleListBlock = (props) => <NewsListBlock {...props} />;

export default ArticleListBlock;



// WEBPACK FOOTER //
// ./src/components/ArticleListBlock/ArticleListBlock.jsx